<template>
  <article
    class="card-container flex flex-row gap-1"
    role="listitem"
    :aria-label="data.title"
    :aria-current="data.active ? 'step' : null"
  >
    <div
      :class="[
        'icon-container flex flex-col justify-center items-center border-transparent rounded-md',
        data.active ? 'bg-white' : 'bg-coverCardDeactivated'
      ]"
    >
      <div class="icon-circle flex flex-col justify-center items-center">
        <img
          v-if="!data.active"
          :class="['svg-filter-inactive']"
          :src="iconImgPath"
          :alt="data.title + ' icon'"
        />
        <loading v-else :icon="data.icon" :duration="2000" />
      </div>
    </div>

    <div
      :class="[
        'content-container w-full bg-white border-transparent rounded-md flex flex-col justify-center',
        data.active ? 'bg-white' : 'bg-coverCardDeactivated'
      ]"
    >
      <h3 class="pl-3 cover-card-title pb-1">{{ data.title }}</h3>
      <p class="px-3 cover-card-content text-sm">{{ data.content }}</p>
    </div>
  </article>
</template>

<script>
import inventoryIcon from '@/images/cover-cards/inventory.svg'
import shippingTruckIcon from '@/images/cover-cards/shipping-truck.svg'
import dealTagIcon from '@/images/cover-cards/deal-tag.svg'
import Loading from './loading.vue'

export default {
  components: {
    Loading
  },
  props: {
    data: Object
  },
  data() {
    return {
      inventory: inventoryIcon,
      shippingTruck: shippingTruckIcon,
      dealTag: dealTagIcon
    }
  },
  computed: {
    iconImgPath () {
      switch (this.data.icon) {
      case 'inventory':
        return this.inventory
      case 'shipping-truck':
        return this.shippingTruck
      case 'deal-tag':
        return this.dealTag
      default:
        return ''
      }
    }
  }
}
</script>

<style scoped>
.card-container {
  border: 1px transparent;
  border-radius: 12px;
}

.svg-filter-active {
  filter: invert(53%) sepia(61%) saturate(4317%) hue-rotate(205deg) brightness(101%) contrast(101%);
}

.svg-filter-inactive {
  filter: invert(71%) sepia(5%) saturate(293%) hue-rotate(172deg) brightness(95%) contrast(87%);
}

.icon-container {
  height: 96px;
  min-width: 96px;
}

.icon-circle {
  height: 64px;
  width: 64px;
  /* border: 1px solid #E0DAD1; */
  border-radius: 100%;
  background-color: #FFFFFF;
}

.content-container {
  width: 100%;
}

.bg-coverCardDeactivated {
  background-color: #E0DAD1;
}

.cover-card-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  letter-spacing: -0.02em;
  color: #334155;
}

.cover-card-content {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #334155;
}
</style>
